export const getCategories = () =>
  useStoryblokApi()
    .get("cdn/datasource_entries", {
      datasource: "blogcategories",
      version: useRuntimeConfig().public.storyblokVersion as
        | "published"
        | "draft"
        | undefined,
    })
    .then((result) => result.data.datasource_entries.map((d: any) => d.value));
